import getScrollBarSize from './getScrollBarSize';
export default (function (close) {
  var bodyIsOverflowing = document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;

  if (!bodyIsOverflowing) {
    return;
  }

  if (close) {
    document.body.style.position = '';
    document.body.style.width = '';
    return;
  }

  var scrollBarSize = getScrollBarSize();

  if (scrollBarSize) {
    document.body.style.position = 'relative';
    document.body.style.width = "calc(100% - ".concat(scrollBarSize, "px)");
  }
});


//////////////////
// WEBPACK FOOTER
// ../~/_rc-util@4.11.0@rc-util/es/switchScrollingEffect.js
// module id = 650
// module chunks = 0